// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"e3d999c4","73":"e941c34a","171":"262ae055","432":"d2e1e076","845":"80356eb4","870":"2f78e7a0"}[chunkId] + ".chunk.js";
};